module.exports = __webpack_public_path__ + "img/info-i.cbc7474b.png";